import React, { createContext, useContext, useState } from 'react';

const CountryContext = createContext();

export const CountryProvider = ({ children }) => {
    const [countryId, setCountryId] = useState(103);

    return (
        <CountryContext.Provider value={{ countryId, setCountryId }}>
            {children}
        </CountryContext.Provider>
    );
};

export const useCountry = () => useContext(CountryContext);
